import React from "react";
import qs from "qs";

class ByPass extends React.Component {
  componentDidMount() {
    /* eslint no-restricted-globals: ["error", "event"] */
    if (location.search) {
      const queryParams = qs.parse(location.search, {
        ignoreQueryPrefix: true,
      });
      const auth = queryParams.auth as any;
      if (auth.uid) {
        localStorage.setItem("auth", JSON.stringify(auth));
      }
    }
    window.location.href = "/my-classes";
  }

  render() {
    return null;
  }
}

export default ByPass;
